import { render } from "./verification.vue?vue&type=template&id=16cf7c64&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"

import "./verification.vue?vue&type=style&index=0&id=16cf7c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cf7c64"]])

export default __exports__